import PolyParameter from 'parameters/PolyParameter.js';
import {setEffectParameterValues} from 'actions/index.js';
import OptionParameter from 'parameters/OptionParameter.js';
import Triggerable from './Triggerable.js';
import {bulkUpdate} from 'utils/bulkUpdate.js';
import {loadParameterFromJson, saveParameterToJson} from 'parameters/parameterJsonFunctions.js';
import {AbstractAudioParamParameter} from 'parameters/AbstractAudioParamParameter.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import {OSCILLATOR} from 'constants/effect-types.js';
import FormantsOscillator from './FormantsOscillator.js';
import {AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';
import AbstractOscillator from './AbstractOscillator.js';
import Tone from 'tone';
import OscParameters from './OscParameters.js';
import OscWaveforms from './OscWaveforms.js';
import OscEnvelopes from './OscEnvelopes.js';
import OscFM from './OscFM.js';
import OscJson from './OscJson.js';
import {compose} from 'utils/compose.js';
import OscVoices from './OscVoices.js';

const RAMP_TIME = 0.1;

// buncha magic numbers fml
window.envelopeTest = false;
window.p1 = 0.05;
window.p2 = 0.008;
window.fuck = 2;

class RackOscillator extends compose(
    OscVoices,
    OscParameters,
    Triggerable,
    OscFM,
    OscEnvelopes,
    OscWaveforms,
    FormantsOscillator,
    OscJson)(
    AbstractOscillator)
{
    constructor(sequencerEngine, mixSession, context, pitchEnvelope, create=true, name, track, instrument) {
        super(
            sequencerEngine,
            mixSession,
            context,
            (polyphony) => new Tone.PolySynth(polyphony, Tone.MonoSynth, {disableFilter: true}),
            pitchEnvelope,
            create,
            track
            );

        this.name = name;
        this.track = track;
        this.instrument = instrument;

        this.create();
        this.setupEnvelopes();
        this.setupFormants();
   }

    get documentation() {
        let name = this.name;
        return `You can connect LFOs to Operator ${name} by dragging a line from an LFO to the circles above the node`;
    }

    getEffectType() {
        return OSCILLATOR;
    }

    disposeSynth(synth=this.synth) {
        let isOffline = synth._voices[0].context.isOffline;
        this.destroyFormants(synth, true);
        synth.formantsManager.dispose();
        if (isOffline) {
            for (let voice of synth.voices) {
                voice.harmonicity.dispose();
                voice.modulationIndex.dispose();
                voice.feedback.dispose();
            }
            synth._voices.forEach(v => v.dispose());
        } else {
            synth._voices.forEach(v => this.releaseVoice(v, false));
        }
        synth._voices = undefined;
    }

}

export default RackOscillator;
